var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.784 55.2998H43.814C50.604 55.2998 56.099 49.7931 56.099 43.0148V32.5498H1.49902V43.0148C1.49902 49.7931 6.99402 55.2998 13.784 55.2998Z",
    fill: "#0091EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.099 15.8667H1.49902V32.55H56.099V15.8667Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.814 0.700195H13.784C6.99402 0.700195 1.49902 6.1952 1.49902 12.9852V15.8669H56.099V12.9852C56.099 6.1952 50.604 0.700195 43.814 0.700195Z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0603 20.335L29.697 15.8317L27.2703 11.69C26.6403 10.605 25.2403 10.2433 24.1553 10.8733C23.0703 11.5033 22.7087 12.9033 23.3387 13.9883L27.0603 20.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0223 10.8851C31.9373 10.2551 30.5373 10.6167 29.9073 11.7017L16.8057 34.0667H22.079L33.839 14.0001C34.469 12.9151 34.1073 11.5151 33.0223 10.8851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7586 41.5332L33.2203 21.8398L32.0653 23.8115C31.3886 25.2582 31.2953 26.8798 31.7853 28.3732L40.8386 43.8315C41.2586 44.5548 42.0169 44.9515 42.7986 44.9515C43.1836 44.9515 43.5803 44.8465 43.9419 44.6365C45.0269 44.0065 45.3886 42.6182 44.7586 41.5332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0271 33.9381L30.7705 33.4948C30.5488 33.1565 30.2921 32.8415 30.0121 32.5498H11.0538C9.79381 32.5498 8.77881 33.5531 8.77881 34.8015C8.77881 36.0498 9.79381 37.0531 11.0538 37.0531H31.3655C31.6571 36.0731 31.5871 34.9648 31.0271 33.9381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6688 41.5914C16.9338 40.7514 15.8605 40.1798 14.5888 40.1331H14.5771C14.0988 40.1214 13.6205 40.1681 13.1655 40.2614L12.4305 41.5331C11.8005 42.6181 12.1621 44.0064 13.2471 44.6481C13.6088 44.8581 14.0055 44.9631 14.3905 44.9631C15.1721 44.9631 15.9305 44.5548 16.3505 43.8431L17.6688 41.5914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1906 32.5615H46.544C47.804 32.5615 48.819 33.5649 48.819 34.8132C48.819 36.0615 47.804 37.0649 46.544 37.0649H38.3656C38.074 36.0732 37.9106 32.8415 38.1906 32.5615Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.798828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.955be2fbcd0fd15acb7b28e9ac463858.svg";
export { ForwardRef as ReactComponent };